class LoginRecovery {
	constructor() {
		// Get the main elements
		this.recoverHeader = document.querySelector("h1#recover");
		this.loginHeader = document.querySelector("h1#login");

		if (!this.recoverHeader || !this.loginHeader) return;

		// Get the form containers - they're the div elements right after the headers
		this.recoverForm = this.recoverHeader.nextElementSibling;
		this.loginForm = this.loginHeader.nextElementSibling;

		// Get the buttons
		this.recoverButton = document.getElementById("recover-password-btn");
		this.loginButton = document.getElementById("login-btn");

		// Set initial state
		this._showLoginForm();

		// Set up event listeners
		this._setupEventListeners();
	}

	_setupEventListeners() {
		if (this.recoverButton) {
			this.recoverButton.addEventListener("click", () => {
				this._showRecoverForm();
			});
		}

		if (this.loginButton) {
			this.loginButton.addEventListener("click", () => {
				this._showLoginForm();
			});
		}
	}

	_showLoginForm() {
		// Hide recover form and show login form
		if (this.recoverForm) this.recoverForm.style.display = "none";
		if (this.recoverHeader) this.recoverHeader.style.display = "none";

		if (this.loginForm) this.loginForm.style.display = "block";
		if (this.loginHeader) this.loginHeader.style.display = "block";
	}

	_showRecoverForm() {
		// Show recover form and hide login form
		if (this.loginForm) this.loginForm.style.display = "none";
		if (this.loginHeader) this.loginHeader.style.display = "none";

		if (this.recoverForm) this.recoverForm.style.display = "block";
		if (this.recoverHeader) this.recoverHeader.style.display = "block";
	}
}

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
	new LoginRecovery();
});
